import { StackGrid } from "@data-display/layout/StackGrid";
import { styled } from "@mui/material";
const PREFIX = "ModalOfferStackGrid";

export const classes = {
  fullWidth: `${PREFIX}-fullWidth`,
};

export const ModalOfferStackGrid = styled(StackGrid)(() => ({
  [`& .${classes.fullWidth}`]: {
    flexBasis: "100%",
  },
}));
